import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { selectNonPinnedVariablesWithInputControl } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { noop } from 'lodash';
import { useOrientation } from '../../context/Orientation';
import { usePreviewSize } from '../../context/PreviewSize';
import { VariableInputControlSlot } from '../../VariableInputControlSlot';
import { GiftWindowStepProps } from '../shared/giftWindowSteps';
import { GiftWindowFooter } from '../shared/partials/GiftWindowFooter';

const _SingleNonPinnedVariableStepWindow = ({
    variable,
    onClose, previous, next,
    previousButtonText
}: Props) => {

    const { t } = useTranslation();
    usePreviewSize('small');
    useOrientation('screen');

    return (
        <WindowContext isOpen close={noop}>
            <WindowContext.Header>
                <WindowHeader previous={previous ?? onClose} onClose={onClose}>
                    {t('windows.non_pinned_variables.heading')}
                </WindowHeader>
            </WindowContext.Header>
            <WindowContext.Body>
                <VariableInputControlSlot variableIds={[variable.id]} />
            </WindowContext.Body>
            <WindowContext.Footer>
                <GiftWindowFooter
                    next={next} nextButtonText={t('commons.continue')}
                    previous={previous} previousButtonText={previousButtonText}
                    onClose={onClose} />
            </WindowContext.Footer>
        </WindowContext>
    );
};

type Props = GiftWindowStepProps & {
    variable: GiftJson.Variable<any>;
};

const mapStateToProps = (state: GiftPdpState) => ({
    variable: selectNonPinnedVariablesWithInputControl(state)[0]
});

export const SingleNonPinnedVariableStepWindow = connect(
    mapStateToProps
)(_SingleNonPinnedVariableStepWindow);